import { z } from 'zod';

// GET /api/v2/agentes/qualidade — evals do Phoenix (span_annotations + experiments).
// response_quality LLM-judge por agente, evaluators code-based, recall@5/MRR do goldset.

export const qualidadeAgenteSchema = z.object({
  projeto: z.string(),
  agent_id: z.string(),
  nome: z.string(),
  dominio: z.string(),
  score: z.number().nullable(),
  n: z.coerce.number(),
  delta: z.number().nullable(),
  ultima: z.string().nullable(),
});
export type QualidadeAgente = z.infer<typeof qualidadeAgenteSchema>;

export const qualidadeEvaluatorSchema = z.object({
  nome: z.string(),
  projeto: z.string(),
  agente: z.string(),
  tipo: z.string(),
  score: z.number().nullable(),
  n: z.coerce.number(),
  ultima: z.string().nullable(),
});
export type QualidadeEvaluator = z.infer<typeof qualidadeEvaluatorSchema>;

export const qualidadeRetrievalSchema = z.object({
  dataset: z.string(),
  agent_id: z.string(),
  nome: z.string(),
  experiment: z.string(),
  data: z.string().nullable(),
  recall_5: z.number().nullable(),
  recall_20: z.number().nullable(),
  mrr: z.number().nullable(),
  n: z.coerce.number(),
});
export type QualidadeRetrieval = z.infer<typeof qualidadeRetrievalSchema>;

export const qualidadeSchema = z.object({
  gerado_em: z.string().nullable(),
  fonte_ok: z.boolean().default(false),
  detail: z.string().optional(),
  resumo: z.object({
    quality_media: z.number().nullable(),
    quality_n: z.coerce.number(),
    evaluators_ativos: z.coerce.number(),
    goldsets: z.coerce.number(),
  }),
  agentes: z.array(qualidadeAgenteSchema).default([]),
  evaluators: z.array(qualidadeEvaluatorSchema).default([]),
  retrieval: z.array(qualidadeRetrievalSchema).default([]),
});
export type Qualidade = z.infer<typeof qualidadeSchema>;
